import { render } from "./NewOpportunities.vue?vue&type=template&id=e28d6f06"
import script from "./NewOpportunities.vue?vue&type=script&lang=js"
export * from "./NewOpportunities.vue?vue&type=script&lang=js"

import "./NewOpportunities.vue?vue&type=style&index=0&id=e28d6f06&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__